<app-navigation
    [footer]="false"
    [additionalContainerClasses]="[]"
    [automaticFooterPadding]="false"
    [hideMainNavigationOnMobile]="true">
    <app-client-dashboard>
        @defer (on immediate) {
            <app-client-dashboard-trip-preparation></app-client-dashboard-trip-preparation>
        }
    </app-client-dashboard>
</app-navigation>
